import { render, staticRenderFns } from "./channelCode.vue?vue&type=template&id=3eac4d87"
import script from "./channelCode.vue?vue&type=script&lang=js"
export * from "./channelCode.vue?vue&type=script&lang=js"
import style0 from "./channelCode.vue?vue&type=style&index=0&id=3eac4d87&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports